import { render } from "./TextareaBrowseItem.vue?vue&type=template&id=78762257"
import script from "./TextareaBrowseItem.vue?vue&type=script&lang=js"
export * from "./TextareaBrowseItem.vue?vue&type=script&lang=js"
script.render = render

export default script